module.exports = __webpack_public_path__ + "static/kids-3bab4fae4b5ba7e874f433c37a61159c.png";